import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "jsx-dom/jsx-runtime";
/** @jsxImportSource jsx-dom */
import { Logger, select } from "@fruugo/utilities";
import { createPictureElement } from "./utilities";
import { Icon } from "./components/Icon";
import { getPromotionalTilesData } from "./api";
import { cmsMasonryImagesSizes, imageFormats } from "../config";
var Log = new Logger(window.environment);
function getPromotionalTiles() {
    var promotionsMount = select("#cms-masonry");
    if (promotionsMount === null)
        return;
    getPromotionalTilesData(cmsMasonryImagesSizes.join(","), imageFormats.join(","))
        .then(buildPromotionalTiles)
        .then(function (tiles) { return addTilesToDom(promotionsMount, tiles); })
        .catch(function (error) { return Log.error(error); });
}
function buildPromotionalTiles(promotionalTiles) {
    if (!promotionalTiles.items)
        return;
    var tileColumnSize = function (index) {
        return "".concat(index <= 2 ? (index !== 2 ? "col-md-6 col-lg-4" : "col-lg-4") : "col-md-6");
    };
    return (_jsx(_Fragment, { children: promotionalTiles.items.map(function (tile, index) { return (_jsxs("a", { href: tile.cta.href, className: "CMS__Masonry__Item Item my-8 my-md-16 ".concat(tileColumnSize(index)), children: [_jsxs("span", { class: "Item__Placeholder__Container", children: [createPictureElement(tile.imageUrl, tile.imageSizes, tile.title, "Item__Image"), _jsx("span", { class: "Item__Placeholder" })] }), _jsx("div", { class: "Item__Background", children: _jsxs("div", { class: "Item__Overlay", children: [_jsx("h3", { class: "Item__Title text-truncate", children: tile.title }), _jsx("p", { class: "Item__Subtitle text-truncate mb-8", children: tile.subtitle }), _jsx("div", { class: "Item__Link text-truncate", children: _jsxs("span", { class: "d-flex align-items-center", children: [tile.cta.text, " ", _jsx(Icon, { name: "back-arrow", "aria-hidden": "true" })] }) })] }) })] })); }) }));
}
function addTilesToDom(element, tiles) {
    if (!element)
        return;
    if (tiles) {
        element.replaceChildren(tiles.cloneNode(true));
    }
    else {
        element.style.display = "none";
    }
}
export function initPromotions() {
    getPromotionalTiles();
}
